// AUTO-GENERATED FILE. Do not edit.
import { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import { PokeType } from "types/pokemon/poke-type";

export const duraludon: PokeData = {
  "id": 884,
  "name": "duraludon",
  "height": 18,
  "weight": 400,
  "base_experience": 187,
  "types": [
    PokeType.STEEL,
    PokeType.DRAGON
  ],
  "api_moves": [
    "leer",
    "hyper-beam",
    "focus-energy",
    "metal-claw",
    "rock-smash",
    "metal-sound",
    "iron-defense",
    "dragon-claw",
    "metal-burst",
    "flash-cannon",
    "hone-claws",
    "dragon-tail",
    "laser-focus",
    "breaking-swipe"
  ],
  "moves": [
    "leer",
    "metal-claw",
    "rock-smash",
    "metal-sound",
    "dragon-claw",
    "metal-burst",
    "iron-defense",
    "dragon-pulse",
    "dragon-rush",
    "behemoth-bash",
    "metal-rush",
    "dragon-breath"
  ],
  "evolution_chain": {
    "id": 465,
    "item": null,
    "species": [
      {
        "name": "duraludon",
        "order": 884,
        "types": [
          PokeType.STEEL,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "archaludon",
        "order": 1020,
        "types": [
          PokeType.STEEL,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 884,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "metal-alloy"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 76.25,
    "speed": 85,
    "ability_power": 120
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
